import { render, staticRenderFns } from "./preDetails.vue?vue&type=template&id=7005e27a&scoped=true&"
import script from "./preDetails.vue?vue&type=script&lang=js&"
export * from "./preDetails.vue?vue&type=script&lang=js&"
import style0 from "./preDetails.vue?vue&type=style&index=0&id=7005e27a&prod&lang=less&"
import style1 from "./preDetails.vue?vue&type=style&index=1&id=7005e27a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005e27a",
  null
  
)

export default component.exports